import { useNavigate } from "react-router-dom";
import { useAppMutation } from "../../../../http/useAppMutation.ts";
import { WORKSPACE_MODELS, WORKSPACES } from "../../../../routes.ts";
import { trackEvent } from "../../../../tracking/tracking.ts";
import { useWorkspaceUuid } from "../../../hooks/useWorkspaceUuid.ts";
import type { ModelType } from "../../../types.ts";

export const useCreateModel = () => {
  const workspaceUuid = useWorkspaceUuid();
  const { mutate, isLoading } = useAppMutation<{ uuid: string }>({
    path: `workspaces/${workspaceUuid}/references`,
    invalidate: [`workspaces/${workspaceUuid}/references`],
    waitForInvalidation: false,
    onSuccess: ({ data }) => {
      trackEvent("reference:create", {
        reference_uuid: data.uuid,
      });
    },
  }).mutation;

  const navigate = useNavigate();

  return {
    createModel: ({ type }: { type: ModelType }) => {
      mutate(
        { name: "", type },
        {
          onSuccess: ({ data }: { data: { uuid: string } }) => {
            navigate(
              `${WORKSPACES}/${workspaceUuid}/${WORKSPACE_MODELS}/${data.uuid}`,
            );
          },
        },
      );
    },
    isCreateModelLoading: isLoading,
  };
};
